import { Link } from "react-router-dom";
import styled from "styled-components";

export const StyledLink = styled(Link)`
    margin-left: 120px;
    transition: 0.4s;
    text-decoration: none;
    &:hover {
        transform: scale(1.1);
    }
`;
export const AppLogoText = styled.h1`
    color: var(--purple-6);
    font-weight: 900;
    font-size: 24px;
    margin: 0;
`;